import { BackendApi } from "./HttpBaseService";

// M1-80 / TRA-O1-53: bandeja de feedback ("Ayudanos a mejorar"). Los filtros
// van en la query string (estado, categoría, fechas); el mensaje y el contacto
// solo vienen en la respuesta, nunca en una URL.
// categoria: undefined = todas, "" = sin categoría.
const ObtenerFeedback = async ({ estado, categoria, desde, hasta, pagina = 1, tamanioPagina = 50 } = {}) => {
  const params = { pagina, tamanioPagina };
  if (estado !== undefined && estado !== null && estado !== "") params.estado = estado;
  if (categoria !== undefined && categoria !== null) params.categoria = categoria;
  if (desde) params.desde = desde;
  if (hasta) params.hasta = hasta;
  return await BackendApi.get(`Feedback`, { params });
};

const CambiarEstadoFeedback = async (id, estado) => {
  return await BackendApi.put(`Feedback/${id}/Estado`, { estado });
};

const FeedbackService = {
  ObtenerFeedback,
  CambiarEstadoFeedback
};

export default FeedbackService;
